<template>
<div id="app" class="site container hfeed" style="height: auto !important">
  <HeadNav selectedLanguage="en" page="download" />

  <div id="content" class="site-content" style="height: auto !important">
    <article id="article" style="height: auto !important">
      <section id="downloadpage" style="height: auto !important;">

        <!-- 下载页面主要内容 -->
         <div class="inside-article">
          <div class="download-hero-section">
          <div class="download-container">
            <!-- 主标题 -->
            <h1 class="main-title">
              Download GB WhatsApp APK Pro Latest Version
            </h1>

            <!-- 描述 -->
            <p class="description">
              We are offering the latest version of this application and you can click on the download button below to get the <a class="jump-url" href="https://gbappapk.org/" target="_blank">latest version of GB WhatsApp</a>. Make sure to enable the option of unknown sources from the settings of your device.
            </p>

            <div style="text-align: center;">
              <img src="@/assets/logo.webp" alt="GB WhatsApp" style="width: 10rem; height: 10rem;"/>
            </div>


            <!-- 应用信息表格 -->
            <div class="app-info-section">
              <div class="app-info-table">
                <table>
                  <tbody>
                    <tr>
                      <th>Application Name</th>
                      <td>GB WhatsApp</td>
                    </tr>
                    <tr>
                      <th>Download</th>
                      <td>10 Millions +</td>
                    </tr>
                    <tr>
                      <th>Developed By</th>
                      <td>Third-Party Developers</td>
                    </tr>
                    <tr>
                      <th>Anti Ban</th>
                      <td>Enabled</td>
                    </tr>
                    <tr>
                      <th>Last Update</th>
                      <td>55 Minutes Ago</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <!-- 下载按钮 -->
            <div class="download-button-section">
              <button
                class="download-btn"
                type="button"
                :disabled="downloadBusy"
                @click="download()"
              >
                <img src="@/assets/android.webp" alt="android icon">
                {{ downloadBusy ? 'Preparing…' : 'Download Now V18.70' }}
              </button>
            </div>

            <!-- 应用介绍 -->
            <div class="app-description">
              <p>
                It has a variety of font themes and wallpapers for WhatsApp. The logo of this WhatsApp is the same as the other version of WhatsApp. It has a dual app setup which means you do not have to uninstall the original version of WhatsApp. You can use both at the same time.
              </p>
            </div>
          </div>
        </div>

        <!-- 下载安装指南 -->
        <div class="download-instructions">
          <h2 class="section-title">How To Download and Install GB WhatsApp?</h2>
          <p>
            Downloading this application is very simple and easy. You need to follow the steps given below to download it on your Android device.
          </p>
          
          <div class="steps-container">
            <div class="step-item">
              <div class="step-number">1</div>
              <div class="step-content">
                <p>Search for <a href="https://gbappapk.org/" target="_blank">https://gbappapk.org/</a> on your browser.</p>
              </div>
            </div>
            
            <div class="step-item">
              <div class="step-number">2</div>
              <div class="step-content">
                <p>Open this website and click on the download button.</p>
              </div>
            </div>
            
            <div class="step-item">
              <div class="step-number">3</div>
              <div class="step-content">
                <p>It will redirect you to the download page and click on the download button again.</p>
              </div>
            </div>
            
            <div class="step-item">
              <div class="step-number">4</div>
              <div class="step-content">
                <p>It will start downloading.</p>
              </div>
            </div>
            
            <div class="step-item">
              <div class="step-number">5</div>
              <div class="step-content">
                <p>Go to the file manager of your device once it is downloaded.</p>
              </div>
            </div>
            
            <div class="step-item">
              <div class="step-number">6</div>
              <div class="step-content">
                <p>Long press on this APK file and click on the install button.</p>
              </div>
            </div>
            
            <div class="step-item">
              <div class="step-number">7</div>
              <div class="step-content">
                <p>It will be installed in a few seconds.</p>
              </div>
            </div>
            
            <div class="step-item">
              <div class="step-number">8</div>
              <div class="step-content">
                <p>Now enter your valid contact number and complete verification.</p>
              </div>
            </div>
            
            <div class="step-item">
              <div class="step-number">9</div>
              <div class="step-content">
                <p>Now, you are in.</p>
              </div>
            </div>
          </div>
        </div>

         </div>
       
      </section>
    </article>
  </div>
</div>
</template>

<script>
import HeadNav from '@/components/HeadNav.vue';

export default {
  name: 'Download',
  data() {
    return {
      pageName: 'download',
      showapk: false,
      // 防止用户在接口返回前连点触发多次下载
      downloadBusy: false,

      apk: null,
      from: 'gb',
      filename: 'gb',
      selectedLanguage: 'en',
    };
  },
  components: {
    HeadNav,
  },
  mounted() {
    this.from = this.$global.GetQueryString('from') || this.from;
    this.filename = this.$global.GetQueryString('filename') || this.filename;
    console.log(this.$global.GetQueryString('from'));
    if (this.$global.GetQueryString('from')) {
      this.getAPK();
    } else {
      this.getOfficalApk();
    }
  },
  methods: {
    downloadfrom(reason) {
      this.download();
      this.$logEvent(`download_from_${reason}`, 'download');
      // window.location.href = `https://gbapp.pro?apps=gb&domain=gbwhatsapp.chat&appName=GB_gbwhatsapp.chat`;
    },
    gotoblog() {
      window.location.href = '/blogs';
    },
    getAPK() {
      return this.$server
        .getAPPInfo({
          promotionChannel: this.from,
          promotionName: this.filename,
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.apk = res.data.apk;
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        })
        .catch(() => {
          // 网络或接口异常时使用环境变量备用链接，保证按钮可用
          this.apk = process.env.VUE_APP_GBLINK;
        });
    },
    getOfficalApk(type = 1, domain = null, appname = null) {
      return this.$server
        .getOfficalApk({
          domain: domain || 'gbwhatsapp.chat',
          appName: appname || 'GB_gbwhatsapp.chat',
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            if (type == 1) {
              this.apk = res.data.apk;
            }
            this.lastupdate = res.data.promotion.updateTime;
            this.votes = res.data.promotion.totalCount;
            this.rating = res.data.promotion.score;
            console.log('apk getted');
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        })
        .catch(() => {
          this.apk = process.env.VUE_APP_GBLINK;
        });
    },
    /**
     * 走与首页一致的接口拿 apk，再调用全局 download
     * 若用户抢先点击，会等 Promise 完成后再触发下载
     */
    download() {
      console.log(this.apk);
      this.$global.download(this.apk);
    },
  },
};
</script>

<style scoped>
/* 下载页面主要样式 */
.download-hero-section {
  background: white;
  border-radius: 12px;
  padding: 40px;
  margin: 20px 0;
  border: 2px solid #1EC0B9;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.inside-article {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}


.download-container {
  max-width: 800px;
  margin: 0 auto;
}

/* 主标题样式 */
.main-title {
  font-size: 2.2em;
  font-weight: bold;
  color: #1EC0B9;
  margin-bottom: 30px;
  line-height: 1.3;
  text-align: center;
}

/* 描述样式 */
.description {
  font-size: 1.1em;
  color: #333;
  margin-bottom: 30px;
  line-height: 1.6;
  margin-left: auto;
  margin-right: auto;
}

/* GB LOGO 样式 */
.gb-logo {
  margin-bottom: 35px;
  text-align: center;
}

.logo-text {
  display: inline-block;
  text-align: center;
}

.gb-text {
  font-size: 32px;
  font-weight: bold;
  color: #1EC0B9;
  display: block;
  line-height: 1;
  margin-bottom: 8px;
}

.whatsapp-text {
  font-size: 26px;
  font-weight: normal;
  color: #333;
  display: block;
}

/* 应用信息表格样式 */
.app-info-section {
  margin: 30px 0;
}

.app-info-table {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  margin: 20px 0;
  border: 1px solid #e8e8e8;
}

.app-info-table table {
  width: 100%;
  border-collapse: collapse;
  background: white;
}

.app-info-table th {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  color: #495057;
  font-weight: 600;
  padding: 16px 20px;
  text-align: left;
  border-bottom: 1px solid #dee2e6;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  min-width: 120px;
}

.app-info-table td {
  padding: 16px 20px;
  border-bottom: 1px solid #f1f3f4;
  color: #212529;
  font-weight: 500;
  font-size: 15px;
}

.app-info-table tr:last-child th,
.app-info-table tr:last-child td {
  border-bottom: none;
}

.app-info-table tr:hover {
  background-color: #f8f9fa;
  transition: background-color 0.2s ease;
}

.app-info-table tr:hover th {
  background: linear-gradient(135deg, #e9ecef 0%, #dee2e6 100%);
}

/* 下载按钮样式 */
.download-button-section {
  margin: 30px 0;
  text-align: center;
}

.download-btn {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  background: #1EC0B9;
  color: white;
  text-decoration: none;
  padding: 18px 35px;
  border-radius: 50px;
  font-weight: bold;
  font-size: 18px;
  transition: all 0.3s ease;
  box-shadow: 0 6px 20px rgba(30, 192, 185, 0.4);
  border: none;
  cursor: pointer;
  min-width: 300px;
  justify-content: center;
}

.download-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 25px rgba(30, 192, 185, 0.5);
  background: #1EC0B9;
}

.download-btn:active {
  transform: translateY(-1px);
}

.download-btn:disabled {
  opacity: 0.85;
  cursor: wait;
  transform: none;
}

.download-btn img {
  width: 28px;
  height: 28px;
  filter: brightness(0) invert(1);
}

/* 应用介绍样式 */
.app-description {
  margin: 30px 0;
}

.app-description p {
  font-size: 1.1em;
  color: #333;
  line-height: 1.6;
  margin: 0 auto;
}

/* 下载安装指南样式 */
.download-instructions {
  background: white;
  border-radius: 12px;
  padding: 40px;
  margin: 20px 0;
  border: 2px solid #1EC0B9;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.section-title {
  color: #1EC0B9;
  font-size: 1.8em;
  font-weight: 700;
  margin-bottom: 20px;
  border-bottom: 3px solid #1EC0B9;
  padding-bottom: 10px;
  text-align: center;
}

.download-instructions > p {
  font-size: 1.1em;
  color: #333;
  margin-bottom: 30px;
  line-height: 1.6;
}

/* 步骤容器样式 */
.steps-container {
  display: grid;
  gap: 20px;
  max-width: 800px;
  margin: 0 auto;
}

.step-item {
  display: flex;
  align-items: flex-start;
  gap: 20px;
  background: white;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border-left: 4px solid #1EC0B9;
  transition: all 0.3s ease;
}

.step-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
}

.step-number {
  background: #1EC0B9;
  color: white;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 18px;
  flex-shrink: 0;
}

.step-content {
  flex: 1;
}

.step-content p {
  margin: 0;
  font-size: 1.1em;
  color: #333;
  line-height: 1.6;
}

.step-content a {
  color: #1EC0B9;
  text-decoration: none;
  font-weight: 500;
}

.step-content a:hover {
  text-decoration: underline;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .download-hero-section {
    padding: 25px 20px;
    margin: 10px;
    border-radius: 8px;
  }

  .main-title {
    font-size: 1.6em;
    margin-bottom: 20px;
  }

  .gb-text {
    font-size: 28px;
  }

  .whatsapp-text {
    font-size: 22px;
  }

  .description {
    font-size: 1em;
    margin-bottom: 20px;
  }

  .download-btn {
    min-width: 250px;
    padding: 15px 25px;
    font-size: 16px;
  }

  .download-btn img {
    width: 24px;
    height: 24px;
  }

  .download-instructions {
    padding: 25px 20px;
    margin: 10px;
  }

  .section-title {
    font-size: 1.5em;
  }

  .step-item {
    flex-direction: column;
    gap: 15px;
  }

  .step-number {
    align-self: center;
  }

  .app-info-table th,
  .app-info-table td {
    padding: 12px 15px;
    font-size: 14px;
  }

  .app-info-table th {
    font-size: 12px;
    min-width: 100px;
  }
}
</style>
